import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Chip,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const SlideViewer = ({ slides, currentSlide, onSlideChange }) => {
  const slide = slides[currentSlide];

  if (!slide) return null;

  const handlePrev = () => {
    if (currentSlide > 0) {
      onSlideChange(currentSlide - 1);
    }
  };

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      onSlideChange(currentSlide + 1);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "360px",
        borderRadius: "12px",
        backgroundColor: "#12162b",
        border: "1px solid rgba(124, 77, 255, 0.2)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Slide header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <Chip
          label={`Slide ${currentSlide + 1} / ${slides.length}`}
          size="small"
          sx={{
            backgroundColor: "rgba(124, 77, 255, 0.15)",
            color: "#7C4DFF",
            fontWeight: 600,
          }}
        />
        <Box>
          <IconButton
            onClick={handlePrev}
            disabled={currentSlide === 0}
            size="small"
            sx={{ color: "#fff" }}
          >
            <ArrowBackIosNewIcon fontSize="small" />
          </IconButton>
          <IconButton
            onClick={handleNext}
            disabled={currentSlide === slides.length - 1}
            size="small"
            sx={{ color: "#fff" }}
          >
            <ArrowForwardIosIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      {/* Slide content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          p: 4,
          textAlign: "center",
        }}
      >
        {slide.image_url && (
          <Box
            component="img"
            src={slide.image_url}
            alt={slide.title}
            sx={{
              maxWidth: "80%",
              maxHeight: "200px",
              borderRadius: "8px",
              mb: 3,
              objectFit: "contain",
            }}
          />
        )}
        <Typography
          variant="h4"
          sx={{
            color: "#fff",
            fontWeight: 700,
            mb: 2,
            fontSize: { xs: "1.5rem", md: "2rem" },
          }}
        >
          {slide.title}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "rgba(255,255,255,0.7)",
            maxWidth: "500px",
            lineHeight: 1.6,
          }}
        >
          {slide.content}
        </Typography>
      </Box>
    </Box>
  );
};

export default SlideViewer;
